export const COMPANY_NAME = 'company_name';
export const AUTH_TOKEN = 'auth_token';
